import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useReservationsList() {
  // Use toast
  const toast = useToast();

  const refReservationListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "voucher_number", label: "編號", class: 'sticky-column', sortable: true },
    { key: "reservation_date", label: "預約日期及時間", class: 'sticky-column', sortable: true },
    { key: "actions", label: "操作", class: 'sticky-column' },
    { key: "invoice_id", stickyColumn: true, label: "發票編號", sortable: true },
    { key: "name_cn", label: "單據抬頭", sortable: true },
    { key: "name", label: "系統帳號名稱", sortable: true },
    { key: "phone", label: "聯絡電話" },
    { key: "reservation_items", label: "預約項目" },
    { key: "address", label: "地址", sortable: true },
    { key: "voucher_status_id", label: "狀態", sortable: true },
    { key: "remark", label: "備註", sortable: true },
    { key: "created_at", label: "創建日期", sortable: true },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refReservationListTable.value
      ? refReservationListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refReservationListTable.value.refresh();
  };

  const reservationsList = ref(null);

  const filter_invoice_id = ref(null);
  const filter_customer_id = ref(null);
  const filter_voucher_status_id = ref(null);

  watch(
    [currentPage, perPage, searchQuery,
      filter_invoice_id,
      filter_customer_id,
      filter_voucher_status_id,
    ],
    () => {
      refetchData();
    }
  );

  const fetchReservations = (ctx, callback) => {
    store
      .dispatch("reservation/fetchReservations", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        invoice_id: filter_invoice_id.value,
        customer_id: filter_customer_id.value,
        voucher_status_id: filter_voucher_status_id.value,
      })
      .then((response) => {
        const { reservation_vouchers, total } = response.data;
        callback(reservation_vouchers);
        console.log('reservation_vouchers', reservation_vouchers)
        totalRow.value = total;
        reservationsList.value = reservation_vouchers
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const invoiceOptions = ref([]);
  const customerOptions = ref([]);
  const voucherStatusOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        invoices: true,
        customers: true,
        voucher_statuses:true,
      })
      .then((response) => {
        invoiceOptions.value = response.data.invoices;
        customerOptions.value = response.data.customers;
        voucherStatusOptions.value = response.data.voucher_statuses;
      });
  };

  onMounted(() => {
    refetchOption();
  });

  return {
    fetchReservations,
    tableColumns,
    perPage,
    totalRow,
    currentPage,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    dataMeta,
    reservationsList,
    refReservationListTable,
    ability,
    refetchData,
    filter_invoice_id,
    filter_customer_id,
    filter_voucher_status_id,
    invoiceOptions,
    customerOptions,
    voucherStatusOptions,
  };
}

